import {
  ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__FAIL,
  ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__REQUEST,
  ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__REQUEST:
    case ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__SUCCESS:
      return null;

    case ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
